import { shallowRef, computed } from 'vue'
import { useRoute } from 'vue-router/composables'
import { get } from '../utils/index'
import { sessionStorage } from 'pangu-core'

export function useTableSort({
  columnUrl,
  columnTableCode,
  column,
  parametersStorageSuffix = '',
  isSession = true,
}) {
  const route = useRoute()
  const sortingsNew = shallowRef([])
  const columns = shallowRef([])

  const setSessionSort = (val) => {
    if (isSession) {
      sessionStorage.set(`${route.name}_plus_page_query_sort_${parametersStorageSuffix}`, val)
    }
  }
  const setDefaultSortings = () => {
    const sessionSort = isSession
      ? sessionStorage.get(`${route.name}_plus_page_query_sort_${parametersStorageSuffix}`)
      : []
    if (sessionSort?.length > 0) {
      sortingsNew.value = sessionSort
    } else {
      const list = Array.isArray(columns.value) ? columns.value : columns.value.items
      sortingsNew.value = list.reduce((pre, cur) => {
        if (cur.sort) {
          if (cur.ascOrder) {
            pre.push({
              field: cur.order || cur.property,
              property: cur.property,
              order: true,
            })
          } else if (cur.ascOrder === false) {
            pre.push({
              field: cur.order ?? cur.property,
              property: cur.property,
              order: false,
            })
          }
        }
        return pre
      }, [])
      setSessionSort(sortingsNew.value)
    }
  }

  const getData = async () => {
    if (column) {
      return column
    } else if (columnTableCode) {
      const [res] = await get(`${columnUrl}${columnTableCode}`)
      return res?.data ?? []
    } else {
      return []
    }
  }
  const getcolumns = async () => {
    columns.value = await getData()
    setDefaultSortings()
  }

  //刷新列定义
  const reloadColumn = () => {
    setSessionSort([])
    return getcolumns()
  }

  const sortChange = (sortList) => {
    sortingsNew.value = sortList.map((im) => {
      return {
        field: im?.column?.params?.order || im.field,
        property: im.property,
        order: im.order === 'asc',
      }
    })
    setSessionSort(sortingsNew.value)
  }

  const tableSortings = computed(() => {
    return sortingsNew.value.map((im) => {
      return {
        field: im.property,
        order: im.order ? 'asc' : 'desc',
      }
    })
  })
  const sortings = computed(() => {
    return sortingsNew.value.map((im) => {
      return {
        field: im.field,
        order: im.order,
      }
    })
  })

  return {
    sortings,
    tableSortings,
    columns,
    getcolumns,
    reloadColumn,
    sortChange,
  }
}
